/**
 * Owner: Haselton Baker Risk Group, LLC
 // Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2/9/18
 * Copyright All Rights Reserved
 */
// @flow
import React from 'react';
import { sp3Logo } from './SP3Logo.module.scss';

const SP3Logo = () => (
  <span className={sp3Logo} />
);

export default SP3Logo;



// WEBPACK FOOTER //
// ./js/components/support/logos/SP3Logo/index.jsx